import { Swiper } from 'swiper';
import { A11y, Pagination, EffectFade, Autoplay } from 'swiper/modules';

const sliders = document.querySelectorAll(
	'.block-hero-display-carousel .swiper'
);

if (sliders.length > 0) {
	sliders.forEach((slider) => {
		const settings = {
			loop: true,
			grabCursor: false,
			spaceBetween: 0,
			slidesPerView: 1,
			modules: [A11y, Pagination, EffectFade, Autoplay],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			autoplay: {
				delay: 5000,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
				dynamicBullets: false,
			},
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
		};

		new Swiper(slider, settings);
	});
}
